// Précautions du bain fleuri — RÉUTILISATION du contenu déjà présent dans le
// guide voyageur (cf. guide.js → chapitre bain de fleurs, bloc "precautions").
// Aucune nouvelle précaution n'est inventée ici : même texte, même formulation.
export const BAIN_PRECAUTIONS = {
  eyebrow: "🌿 Quelques précautions",
  title: "Avant de profiter du bain",
  intro:
    "Le bain floral est préparé avec des fleurs fraîches soigneusement sélectionnées et adaptées à cette expérience.",
  avoid: [
    "d'allergie connue aux fleurs, plantes ou parfums naturels",
    "de peau très sensible, irritée ou présentant une lésion",
    "de problème dermatologique en cours",
  ],
  tips: [
    "une durée de bain de 30 à 45 minutes",
    "un rinçage à l'eau claire après utilisation",
  ],
  footer:
    "En cas de grossesse, d'allaitement ou de doute médical particulier, il est préférable de demander conseil à un professionnel de santé avant utilisation.",
};
